import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { map } from 'lodash';

import { WMS_VERSIONS } from '../../../api/Layers/Layers';
import { getWMSVersion } from '../../../api/Layers/layer-operations';

const LayerWMSVersionField = ({ layer }) => (
  <Form.Group>
    <Form.Label>WMS Version</Form.Label>
    <Form.Control
      as="select"
      name="wmsVersion"
      defaultValue={getWMSVersion(layer)}
      placeholder="What's the code name for the styles?"
    >
      {map(WMS_VERSIONS.properties, ({ name, value, humanValue }) => (
        <option key={name} value={value}>
          {humanValue}
        </option>
      ))}
    </Form.Control>
  </Form.Group>
);

LayerWMSVersionField.propTypes = {
  layer: PropTypes.object.isRequired
};

export default LayerWMSVersionField;
